import { PolicyEngineGraphData, PolicyEngineDetailsTabInfo, PolicyEngineTableData } from './PolicyEngineInterface';

interface PolicyEngineAggregatedData {
  policyEngineGraphData: PolicyEngineGraphData;
  policyEngineDetailsTabData?: PolicyEngineDetailsTabInfo;
}

export const aggregatePolicyEngineSummaryData = (policyEngineData: PolicyEngineAggregatedData) => {
  // Aggregate Policy Engine data for AI summary
  const risksByTeamAndManager = policyEngineData.policyEngineDetailsTabData?.risksByTeamAndManager_Monthly;
  return {
    policyEngineGraphData: policyEngineData.policyEngineGraphData || ({} as PolicyEngineGraphData),
    risksByTeamAndManager:
      risksByTeamAndManager === undefined
        ? policyEngineData.policyEngineDetailsTabData
          ? undefined
          : ({} as PolicyEngineTableData)
        : risksByTeamAndManager || ({} as PolicyEngineTableData)
  };
};
